import ExpandButton from './ExpandButton';
import { useToggleExpand, useGetLinks } from './hooks';
import InternalLink from './InternalLink';
import {
  InternalLinkModWrapper,
  InternalLinkModOverview,
  InternalModLinks,
  InternalLinkModTitle,
  InternalLinkModArea
} from './InternalLinkMod.styles';
import { InternalLinkModContext } from './InternalLinkModProvider';

type OwnProps = {
  linkKey: string;
  maxLinks?: number;
  minLinks?: number;
  urlRoot?: string;
};

export default function InternalLinkMod({
  linkKey,
  maxLinks,
  minLinks = 9,
  urlRoot = '/cars'
}: OwnProps) {
  const [isExpanded, toggle] = useToggleExpand();
  const getLinks = useGetLinks(InternalLinkModContext);
  const { links = [], title: sectionTitle = '' } = getLinks(linkKey);
  const minOrMaxLinks = !isExpanded ? minLinks : maxLinks;
  const linkLength = minOrMaxLinks || links.length;
  const linksToSlice = links.slice(0, linkLength);
  const isNotDivisibleByThree = linkLength % 3 !== 0;
  const showViewMoreButton = links.length > 9;
  const cvTag = sectionTitle.replace(/[ ,.]/g, '');

  return links.length ? (
    <InternalLinkModWrapper data-cv-test={cvTag}>
      <InternalLinkModOverview>
        <InternalModLinks>
          <InternalLinkModTitle>{sectionTitle}</InternalLinkModTitle>
          <InternalLinkModArea isNotDivisibleByThree={isNotDivisibleByThree}>
            {linksToSlice.map(({ link, text }, index: number) => (
              <InternalLink
                key={link}
                isVisible={index < minLinks || isExpanded}
                link={link}
                urlRoot={urlRoot}
                title={text}
              />
            ))}
          </InternalLinkModArea>
          {showViewMoreButton && (
            <ExpandButton toggleExpand={toggle} isExpanded={isExpanded} />
          )}
        </InternalModLinks>
      </InternalLinkModOverview>
    </InternalLinkModWrapper>
  ) : null;
}
